import PaymentNotChargedNotice from '@/components/payouts/failure/PaymentNotChargedNotice';
import { Alert, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PayoutDeclinedAlertProps {
  /** The provider's reason for the refusal, null when it gave none. */
  failureCode: string | null;
}

/**
 * A refused payment attempt on a batch that stays payable. No new payout is
 * offered here: the brand resumes this one from the payouts list.
 */
const PayoutDeclinedAlert: React.FC<PayoutDeclinedAlertProps> = ({ failureCode }) => {
  const { t } = useTranslation();

  return (
    <Alert.Root status="error" variant="subtle">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title>{t('payouts.failure.declinedTitle')}</Alert.Title>
        <Alert.Description>
          <VStack align="start" gap={3} mt={2}>
            <PaymentNotChargedNotice failureCode={failureCode} />
            <Text color="fg.muted" fontSize="sm">
              {t('payouts.failure.retryHint')}
            </Text>
          </VStack>
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
};

export default PayoutDeclinedAlert;
